import { useState, useCallback } from 'react';

export interface TicketSelectionState {
  selectedTickets: Set<string>;
  isAllSelected: boolean;
  isIndeterminate: boolean;
}

export function useTicketSelection(tickets: any[]) {
  const [selectedTickets, setSelectedTickets] = useState<Set<string>>(new Set());

  const isAllSelected = tickets.length > 0 && selectedTickets.size === tickets.length;
  const isIndeterminate = selectedTickets.size > 0 && selectedTickets.size < tickets.length;

  const toggleTicket = useCallback((ticketId: string) => {
    setSelectedTickets(prev => {
      const newSet = new Set(prev);
      if (newSet.has(ticketId)) {
        newSet.delete(ticketId);
      } else {
        newSet.add(ticketId);
      }
      return newSet;
    });
  }, []);

  const toggleAllTickets = useCallback(() => {
    if (isAllSelected) {
      setSelectedTickets(new Set());
    } else {
      setSelectedTickets(new Set(tickets.map(ticket => ticket.id)));
    }
  }, [tickets, isAllSelected]);

  const clearSelection = useCallback(() => {
    setSelectedTickets(new Set());
  }, []);

  const getSelectedTicketsData = useCallback(() => {
    return tickets.filter(ticket => selectedTickets.has(ticket.id));
  }, [tickets, selectedTickets]);

  return {
    selectedTickets,
    isAllSelected,
    isIndeterminate,
    toggleTicket,
    toggleAllTickets,
    clearSelection,
    getSelectedTicketsData,
    hasSelection: selectedTickets.size > 0
  };
}
